module.exports = __webpack_public_path__ + "img/hero-img.0277ba51.png";